module.exports = __webpack_public_path__ + "static/media/icw_newsImg.24fb638c.svg";